App.ModifierGroupModifierItemComponent = Em.Component.extend
  classNames: [ 'modifier-group-modifier-item' ]

  # classNameBindings: ['modifierGroup.visible:visible']

  store:    Em.inject.service()
  modifier: null
  openedAvailability: false

  # Доступности в ресторанах для текущего пользователя
  visibleModifierAvailability: (->
    restaurants  = @get('modifier.organization.restaurants')
    availability = @get('modifier.availability')

    return [] unless Em.isArray(restaurants) and Em.isArray(availability)

    restaurant_ids = restaurants.map (r) => r.get('id')

    availability.filter (av) =>
      av.get('restaurant_id').toString() in restaurant_ids
  ).property('restaurants.[]', 'modifier.availability.[]')

  # Есть ли статус в одном из ресторанов, отличный от доступного
  hasAvailabilityConditions: (->
    @get('visibleModifierAvailability').any (av) =>
      av.get('status') isnt 'available'
  ).property('visibleModifierAvailability.@each.status')

  click: (event) ->
    # Проверка, что поповер не кликнули
    if Em.$(event.target).parents('.visibility-settings-popover').length == 0
      @sendAction('action', @get('modifier'))

  saveModifierAvailabilityDo: ->
    @get('modifier')?.save()
    .then (data) =>
      @get('modifier').reload()

  actions:
    openAvailability: ->
      Em.run.later =>
        @set('openedAvailability', true)
      , 200

    saveModifierAvailability: ->
      Em.run.debounce @, @saveModifierAvailabilityDo, 2000
      false
